import Image from 'next/legacy/image';
import Button from '@components/atoms/button';
import { BodyRegular } from '@components/atoms/typography';
import { Auth0UserInfo } from '@lib/auth0/utils';
import { getUserSubscriptionInfo } from '@lib/utils';

type CancelPlanProps = {
  setIsCancelPlanOpen: (boolean) => void;
  user: Auth0UserInfo;
};

const CancelPlan = ({ setIsCancelPlanOpen, user }: CancelPlanProps) => {
  const userSubInfo = getUserSubscriptionInfo(user);
  return (
    <div className="p-6 min-w-80 md:min-w-60 xl:min-w-50 md:min-h-20 max-h-screen">
      <div className="flex justify-center">
        <Image
          className="w-full lg:rounded-lg"
          src={'/images/pep2.png'}
          height={380}
          width={305}
          priority
          alt="fantasy football hub"
        />
      </div>
      <div className="flex flex-col justify-center p-6">
        <BodyRegular>
          Since you signed up via{' '}
          {userSubInfo?.source?.provider === 'paypal' ? 'Paypal' : 'the app'},
          please cancel your subscription there.
        </BodyRegular>
        <div className="flex justify-evenly my-6">
          <div>
            <Button
              onClick={() => {
                setIsCancelPlanOpen(false);
              }}
              variant="danger"
            >
              Got it
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelPlan;
